AFRAME.registerComponent("cardboard-camera", {});
